export { globalSearch, closeNavSearch, navigateSearchResult, CATEGORY_META } from './globalSearch.js'
